import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";

export const getBatchesInfo = async ({
  itemCode,
  docValues,
  row,
  serie2,
  setMsg,
  logoutAction,
}: stdObject) => {
  let resultBatches: stdObject = { available: [], batches: [] };

  if (["ENT", "CFA"].includes(docValues.type)) {
    if (!("BATCHES" in row)) {
      row.BATCHES = [];
    }
    resultBatches = {
      available: [],
      batches: row.BATCHES.map((e: stdObject) => {
        return { data: e };
      }),
    };
  } else {
    setMsg("loading");
    const payloadBatches = {
      type: docValues.type,
      serie: docValues.serie,
      serie2,
      code: docValues.code,
      line: row[`LIN${docValues.itemType}`],
      item: itemCode,
      isTransferIn: docValues.isTransferIn,
      batches:
        serie2 && row[`LIN${docValues.itemType}`] in docValues.batches
          ? docValues.batches[row[`LIN${docValues.itemType}`]].map(
              (e: stdObject) => e.data,
            )
          : (docValues.batches[row[`LIN${docValues.itemType}`]] ?? false),
    };
    console.log("payloadBatches: ", payloadBatches);
    resultBatches = await sendData({
      endPoint: "callBatches",
      payload: payloadBatches,
      logoutAction,
    });
  }
  // console.log("resultBatches: ", resultBatches);
  return resultBatches;
};
